import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { GetSiteParams, Site } from "./apiEcms.types";

const getSite = async (
  { customerId, contractId, siteId }: GetSiteParams,
  signal: AbortSignal,
) => {
  const { data } = await apiEcmsHttp.get<Site>(
    `/customers/${customerId}/contracts/${contractId}/sites/${siteId}`,
    { signal },
  );

  return data;
};

export const useGetSite = ({
  customerId,
  contractId,
  siteId,
}: GetSiteParams) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [QUERY_KEYS.SITE, customerId, contractId, siteId, currentGroup],
    queryFn: ({ signal }) =>
      getSite({ customerId, contractId, siteId }, signal),
  });
};
